import { Component, ReactNode } from 'react';
import { NavLink, useNavigate, useParams } from 'react-router';
import { toast } from 'react-toastify';
import { AdminApi } from '../admin-api';
import Header from './Header';
import LoadingButton from './LoadingButton';
import PageLoading from './PageLoading';
import Sidebar from './Sidebar';

export default function PeoplePassword(props: any): ReactNode {
  return (
    <PeoplePasswordComp
      navigate={useNavigate()}
      params={useParams()}
      {...props}
    />
  );
}

class PeoplePasswordComp extends Component {
  constructor(
    readonly props: Readonly<{
      children?: ReactNode;
      navigate?: any;
      currentUser?: any;
      params?: any;
    }>,
  ) {
    super(props);
    this.state = {
      isLoading: true,
      isSubmitting: false,
      data: null,
    };
  }

  state: Readonly<{
    isLoading: boolean;
    isSubmitting: boolean;
    data: {
      id: number;
      name: string;
      password: string;
      confirm: string;
    } | null;
  }>;

  async componentDidMount(): Promise<void> {
    const _id = this.props.params.id;

    this.checkAccess();

    const _data = await AdminApi.get(`/users/${_id}`);
    this.setState({
      isLoading: false,
      data: _data,
      uploadedProfile: _data?.profilePhotoUrl,
    });
  }

  async submit() {
    let _result = null;

    this.checkAccess();

    this.setState({ isSubmiting: true });

    _result = await AdminApi.put(`/users/${this.state.data?.id}/password`, {
      password: this.state.data?.password,
      confirm: this.state.data?.confirm,
    });

    this.setState({ isSubmiting: false });

    if (_result) {
      toast.success('Senha atualizada com sucesso!');

      setTimeout(() => {
        this.props.navigate(
          this.props.currentUser.role === 'admin' ? '/people' : '/',
        );
      }, 200);
    }
  }

  canSubmit() {
    return (
      this.state.data?.password?.length && this.state.data?.confirm?.length
    );
  }

  checkAccess() {
    if (
      !this.props.params.id ||
      (this.props.currentUser.role !== 'admin' &&
        this.props.currentUser.id !== parseInt(this.props.params.id))
    ) {
      setTimeout(() => {
        this.props.navigate('/');
      });

      return;
    }
  }

  render(): ReactNode {
    return this.state.isLoading ? (
      <PageLoading />
    ) : (
      <div>
        <Header
          navigate={this.props.navigate}
          currentUser={this.props.currentUser}
        ></Header>
        <div className="container-fluid">
          <div className="row">
            <Sidebar
              navigate={this.props.navigate}
              currentUser={this.props.currentUser}
            ></Sidebar>
            <main className="large-calendar ms-sm-auto px-md-4">
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2">
                  {this.state.data?.id
                    ? `Alterar senha ${this.state.data?.name}`
                    : 'Adicionar pessoa'}
                </h1>
              </div>
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/people">Lista de pessoas</NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Alterar senha
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="mb-3">
                      <label className="form-label">Senha</label>
                      <input
                        type="password"
                        className="form-control"
                        onChange={(e) =>
                          this.setState({
                            data: {
                              ...this.state.data,
                              password: e.target.value,
                            },
                          })
                        }
                        value={this.state.data?.password}
                      />
                      <div id="emailHelp" className="form-text">
                        Nova senha para acesso
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Confirmação</label>
                      <input
                        type="password"
                        className="form-control"
                        onChange={(e) =>
                          this.setState({
                            data: {
                              ...this.state.data,
                              confirm: e.target.value,
                            },
                          })
                        }
                        value={this.state.data?.confirm}
                      />
                      <div id="emailHelp" className="form-text">
                        Repita a senha acima
                      </div>
                    </div>

                    <div className="d-grid gap-2">
                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={this.state.isSubmitting || !this.canSubmit()}
                        onClick={() => this.submit()}
                      >
                        {this.state.isSubmitting ? (
                          <LoadingButton />
                        ) : (
                          `Atualizar Senha`
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}
